import Vue from 'vue';
import StormUsers from './storm-users';
import MyProfile from './my-profile';

export default Vue.component('storm-settings-modal', {
  template: require('./template.html'),
  name: 'storm-dashboard-settings',
  computed: {
    pages() {
      return {
        'storm-users': StormUsers,
        'my-profile': MyProfile,
      };
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  props: ['modal'],
});



// WEBPACK FOOTER //
// ./src/storm/pages/settings-modal/index.js